var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('SiteInfo'),_c('standings'),_c('Notice'),_c('NewlyArticle'),_c('TagCloud')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }